 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import UNTITLED12 from '@/components/Untitled12'
 import UNTITLED13 from '@/components/Untitled13'
 import UNTITLED14 from '@/components/Untitled14'
 import UNTITLED15 from '@/components/Untitled15'
 import UNTITLED16 from '@/components/Untitled16'
 import UNTITLED17 from '@/components/Untitled17'
 import UNTITLED18 from '@/components/Untitled18'
 import UNTITLED19 from '@/components/Untitled19'
 import UNTITLED110 from '@/components/Untitled110'
 import UNTITLED111 from '@/components/Untitled111'
 import UNTITLED112 from '@/components/Untitled112'
 import UNTITLED113 from '@/components/Untitled113'
 import UNTITLED114 from '@/components/Untitled114'
 import UNTITLED115 from '@/components/Untitled115'
 import UNTITLED116 from '@/components/Untitled116'
 import UNTITLED117 from '@/components/Untitled117'
 import UNTITLED118 from '@/components/Untitled118'
 import UNTITLED119 from '@/components/Untitled119'
 import UNTITLED120 from '@/components/Untitled120'
 import UNTITLED121 from '@/components/Untitled121'
 import UNTITLED122 from '@/components/Untitled122'
 import UNTITLED123 from '@/components/Untitled123'
 import UNTITLED124 from '@/components/Untitled124'
 import UNTITLED125 from '@/components/Untitled125'
 import UNTITLED126 from '@/components/Untitled126'
 import UNTITLED127 from '@/components/Untitled127'
 import UNTITLED128 from '@/components/Untitled128'
 import UNTITLED129 from '@/components/Untitled129'
 import UNTITLED130 from '@/components/Untitled130'
 import UNTITLED131 from '@/components/Untitled131'
 import UNTITLED132 from '@/components/Untitled132'
 import UNTITLED133 from '@/components/Untitled133'
 import UNTITLED134 from '@/components/Untitled134'
 import UNTITLED135 from '@/components/Untitled135'
 import UNTITLED136 from '@/components/Untitled136'
 import UNTITLED137 from '@/components/Untitled137'
 import UNTITLED138 from '@/components/Untitled138'
 import UNTITLED139 from '@/components/Untitled139'
 import UNTITLED140 from '@/components/Untitled140'
 import UNTITLED141 from '@/components/Untitled141'
 import UNTITLED142 from '@/components/Untitled142'
 import UNTITLED143 from '@/components/Untitled143'
 import UNTITLED144 from '@/components/Untitled144'
 import UNTITLED145 from '@/components/Untitled145'
 import UNTITLED146 from '@/components/Untitled146'
 import UNTITLED147 from '@/components/Untitled147'
 import UNTITLED148 from '@/components/Untitled148'
 import UNTITLED149 from '@/components/Untitled149'
 import UNTITLED150 from '@/components/Untitled150'
 import UNTITLED151 from '@/components/Untitled151'
 import UNTITLED152 from '@/components/Untitled152'
 import UNTITLED153 from '@/components/Untitled153'
 import UNTITLED154 from '@/components/Untitled154'
 import UNTITLED155 from '@/components/Untitled155'
 import UNTITLED156 from '@/components/Untitled156'
 import UNTITLED157 from '@/components/Untitled157'
 import UNTITLED158 from '@/components/Untitled158'
 import UNTITLED159 from '@/components/Untitled159'
 import UNTITLED160 from '@/components/Untitled160'
 import UNTITLED161 from '@/components/Untitled161'
 import UNTITLED162 from '@/components/Untitled162'
 import UNTITLED163 from '@/components/Untitled163'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
		{
 			"path" : "/",
 			"name" : "home",
 			"components" : {
				default: Home
			}
 		},
 		{
 			"path" : "/tcpage1",
 			"name" : "tcpage1"
 			,"components" : {
				 left: UNTITLED12
				 ,
				 right: UNTITLED13
			}
 		},
 		{
 			"path" : "/tcpage2",
 			"name" : "tcpage2"
 			,"components" : {
				 left: UNTITLED14
				 ,
				 right: UNTITLED15
			}
 		},
 		{
 			"path" : "/tcpage3",
 			"name" : "tcpage3"
 			,"components" : {
				 left: UNTITLED16
				 ,
				 right: UNTITLED17
			}
 		},
 		{
 			"path" : "/tcpage4",
 			"name" : "tcpage4"
 			,"components" : {
				 left: UNTITLED18
				 ,
				 right: UNTITLED19
			}
 		},
 		{
 			"path" : "/tcpage5",
 			"name" : "tcpage5"
 			,"components" : {
				 left: UNTITLED110
				 ,
				 right: UNTITLED111
			}
 		},
 		{
 			"path" : "/tcpage6",
 			"name" : "tcpage6"
 			,"components" : {
				 left: UNTITLED112
				 ,
				 right: UNTITLED113
			}
 		},
 		{
 			"path" : "/tcpage7",
 			"name" : "tcpage7"
 			,"components" : {
				 left: UNTITLED114
				 ,
				 right: UNTITLED115
			}
 		},
 		{
 			"path" : "/tcpage8",
 			"name" : "tcpage8"
 			,"components" : {
				 left: UNTITLED116
				 ,
				 right: UNTITLED117
			}
 		},
 		{
 			"path" : "/tcpage9",
 			"name" : "tcpage9"
 			,"components" : {
				 left: UNTITLED118
				 ,
				 right: UNTITLED119
			}
 		},
 		{
 			"path" : "/tcpage10",
 			"name" : "tcpage10"
 			,"components" : {
				 left: UNTITLED120
				 ,
				 right: UNTITLED121
			}
 		},
 		{
 			"path" : "/tcpage11",
 			"name" : "tcpage11"
 			,"components" : {
				 left: UNTITLED122
				 ,
				 right: UNTITLED123
			}
 		},
 		{
 			"path" : "/tcpage12",
 			"name" : "tcpage12"
 			,"components" : {
				 left: UNTITLED124
				 ,
				 right: UNTITLED125
			}
 		},
 		{
 			"path" : "/tcpage13",
 			"name" : "tcpage13"
 			,"components" : {
				 left: UNTITLED126
				 ,
				 right: UNTITLED127
			}
 		},
 		{
 			"path" : "/tcpage14",
 			"name" : "tcpage14"
 			,"components" : {
				 left: UNTITLED128
				 ,
				 right: UNTITLED129
			}
 		},
 		{
 			"path" : "/tcpage15",
 			"name" : "tcpage15"
 			,"components" : {
				 left: UNTITLED130
				 ,
				 right: UNTITLED131
			}
 		},
 		{
 			"path" : "/tcpage16",
 			"name" : "tcpage16"
 			,"components" : {
				 left: UNTITLED132
				 ,
				 right: UNTITLED133
			}
 		},
 		{
 			"path" : "/tcpage17",
 			"name" : "tcpage17"
 			,"components" : {
				 left: UNTITLED134
				 ,
				 right: UNTITLED135
			}
 		},
 		{
 			"path" : "/tcpage18",
 			"name" : "tcpage18"
 			,"components" : {
				 left: UNTITLED136
				 ,
				 right: UNTITLED137
			}
 		},
 		{
 			"path" : "/tcpage19",
 			"name" : "tcpage19"
 			,"components" : {
				 left: UNTITLED138
				 ,
				 right: UNTITLED139
			}
 		},
 		{
 			"path" : "/tcpage20",
 			"name" : "tcpage20"
 			,"components" : {
				 left: UNTITLED140
				 ,
				 right: UNTITLED141
			}
 		},
 		{
 			"path" : "/tcpage21",
 			"name" : "tcpage21"
 			,"components" : {
				 left: UNTITLED142
				 ,
				 right: UNTITLED143
			}
 		},
 		{
 			"path" : "/tcpage22",
 			"name" : "tcpage22"
 			,"components" : {
				 left: UNTITLED144
				 ,
				 right: UNTITLED145
			}
 		},
 		{
 			"path" : "/tcpage23",
 			"name" : "tcpage23"
 			,"components" : {
				 left: UNTITLED146
				 ,
				 right: UNTITLED147
			}
 		},
 		{
 			"path" : "/tcpage24",
 			"name" : "tcpage24"
 			,"components" : {
				 left: UNTITLED148
				 ,
				 right: UNTITLED149
			}
 		},
 		{
 			"path" : "/tcpage25",
 			"name" : "tcpage25"
 			,"components" : {
				 left: UNTITLED150
				 ,
				 right: UNTITLED151
			}
 		},
 		{
 			"path" : "/tcpage26",
 			"name" : "tcpage26"
 			,"components" : {
				 left: UNTITLED152
				 ,
				 right: UNTITLED153
			}
 		},
 		{
 			"path" : "/tcpage27",
 			"name" : "tcpage27"
 			,"components" : {
				 left: UNTITLED154
				 ,
				 right: UNTITLED155
			}
 		},
 		{
 			"path" : "/tcpage28",
 			"name" : "tcpage28"
 			,"components" : {
				 left: UNTITLED156
				 ,
				 right: UNTITLED157
			}
 		},
 		{
 			"path" : "/tcpage29",
 			"name" : "tcpage29"
 			,"components" : {
				 left: UNTITLED158
				 ,
				 right: UNTITLED159
			}
 		},
 		{
 			"path" : "/tcpage30",
 			"name" : "tcpage30"
 			,"components" : {
				 left: UNTITLED160
				 ,
				 right: UNTITLED161
			}
 		},
 		{
 			"path" : "/tcpage31",
 			"name" : "tcpage31"
 			,"components" : {
				 left: UNTITLED162
				 ,
				 right: UNTITLED163
			}
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"components" : {
				default: Last
			}
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js